import React from 'react';
import button from "bootstrap/js/src/button";

const BackButton = (props) => {
    const {
        onClick     = () => {},
        disabled    = false,
        style       = null,
        hideIcons   = false,
        label       = 'Back',
    } = props;

    const renderIcons = () => {
        if (hideIcons) {
            return null;
        }

        return (
            <React.Fragment>
                &larr;&nbsp;
            </React.Fragment>
        )
    }

    return (
        <button onClick={() => onClick()}
                disabled={disabled}
                className={'back-button'}
                style={style}
        >
            <span>{renderIcons()}{label}</span>
        </button>
    )
}

export default BackButton;
